<template>
  <layout title="Dashboard">
    <div class="flex justify-center">
      <div class="md:p-8 p-4 !pb-28 max-w-7xl w-full flex items-stretch">
        <sideMenu />
        <div class="flex flex-col flex-1 md:ml-8 ml-4">
          <div class="sm:grid grid-flow-col lg:grid-cols-3 grid-cols-2 gap-6">
            <div
              class="
                font-black
                text-3xl text-gray-800
                inline-block
                lg:col-span-2
                col-span-1
              "
            >
              Dashboard
            </div>
            <div
              class="
                col-span-1
                w-full
                bg-white
                shadow-allArround
                flex
                rounded-xl
                mt-6
                sm:mt-0
              "
              v-if="Object.keys(product).length > 0"
            >
              <date-range-picker
                id="piker"
                ref="picker"
                :locale-data="{ firstDay: 1, format: 'dd/mm/yyyy' }"
                :showWeekNumbers="false"
                :autoApply="true"
                single-date-picker="range"
                :ranges="false"
                :max-date="new Date().toISOString().slice(0, 10)"
                :linkedCalendars="false"
                v-model="dateRange"
                @update="updateValues"
                @toggle="checkOpen"
                @hoverDate="hoverDates"
                @startSelection="selectionStartDate"
                @finishSelection="selectionEndDate"
              >
                <template v-slot:input="picker" style="min-width: 350px">
                  {{ picker.rangeText }}
                </template>
              </date-range-picker>
              <div
                class="flex items-center px-1.5 rounded-r-xl cursor-pointer"
                style="border: 1px solid #ccc"
                @click.stop.prevent="$refs.picker.togglePicker(true)"
              >
                <CalendarIcon />
              </div>
            </div>
          </div>
          <alertBox>
            The number of API Calls can take up to 2 hours to refresh.
          </alertBox>
          <div class="sm:grid grid-flow-col lg:grid-cols-3 grid-cols-2 gap-6">
            <div
              class="mt-6 bg-white shadow-allArround rounded-xl flex-1 relative"
              v-if="
                productLoading ||
                remainderLoading ||
                Object.keys(product).length > 0
              "
            >
              <PuSkeleton
                class="h-full w-full z-10 rounded-xl absolute"
                v-if="productLoading || remainderLoading"
              />
              <div class="p-4 bg-gray-200 font-bold text-xl rounded-t-xl">
                Plan Subscribed
              </div>
              <div class="p-4 text-gray-800">
                <p class="font-bold">{{ product.name }}</p>
                <div>
                  <p class="inline-block mt-2 font-bold">
                    {{ product.price | price }}€
                  </p>
                  <p class="inline-block">/ {{ product.subscriptionTime }}</p>
                </div>
              </div>
            </div>
            <div
              class="
                mt-6
                bg-white
                row-start-2
                lg:row-start-1
                col-span-1
                lg:col-span-1
                shadow-allArround
                rounded-xl
                flex-1
                relative
              "
              v-if="
                productLoading ||
                remainderLoading ||
                Object.keys(product).length > 0
              "
            >
              <PuSkeleton
                class="h-full w-full z-10 rounded-xl absolute"
                v-if="productLoading || remainderLoading"
              />
              <div class="p-4 bg-gray-200 font-bold text-xl rounded-t-xl">
                API Calls
              </div>
              <div class="relative p-2 flex" v-if="product.transactions > 0">
                <div
                  class="absolute top-9 font-bold text-primary-color"
                  style="width: 50px; left: 33px; text-align: center"
                >
                  {{ percentageUsageApi }}%
                </div>
                <div id="donut">
                  <donut
                    :usedApiCalls="usedApiCalls"
                    :totalPlan="product.transactions"
                    :render="!productLoading && !remainderLoading"
                  />
                </div>
                <div class="flex flex-col justify-center ml-4 text-gray-800">
                  <p class="font-bold">
                    {{ usedApiCalls }} / {{ product.transactions }}
                  </p>
                  <p>per month</p>
                </div>
              </div>
              <div class="p-4 flex items-center" v-else>
                <div class="flex justify-center text-gray-800 space-x-2">
                  <p>Used this month:</p>
                  <p class="font-bold">
                    {{ usedApiCalls }}
                  </p>
                </div>
              </div>
            </div>
            <div
              class="mt-6 bg-white shadow-allArround rounded-xl flex-1 relative"
              v-if="
                productLoading ||
                remainderLoading ||
                planLoading ||
                (Object.keys(product).length > 0 &&
                  Object.keys(currPlan).length > 0)
              "
            >
              <PuSkeleton
                class="h-full w-full z-10 rounded-xl absolute"
                v-if="productLoading || remainderLoading || planLoading"
              />
              <div class="p-4 bg-gray-200 font-bold text-xl rounded-t-xl">
                Next Payment
              </div>
              <div class="p-4 text-gray-800 space-y-2">
                <p v-if="currPlan.next_bill_date">
                  {{ currPlan.next_bill_date | formatDate }}
                </p>
                <div>
                  <p class="inline-block">Payment amount:</p>
                  <p class="inline-block font-bold">
                    {{   product.next_price_value | price }}€
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="flex flex-1">
            <div
              class="mt-6 bg-white shadow-allArround rounded-xl flex-1 relative"
              v-if="
                productLoading ||
                remainderLoading ||
                statisticsLoading ||
                Object.keys(product).length > 0
              "
            >
              <PuSkeleton
                class="h-full w-full z-20 rounded-xl absolute"
                v-if="productLoading || remainderLoading || statisticsLoading"
              />
              <div
                class="
                  p-4
                  bg-gray-200
                  font-bold
                  text-xl
                  rounded-t-xl
                  sm:flex
                  block
                  justify-between
                  items-center
                "
              >
                <div>Statistics</div>
                <inertia-link :href="$route('user.statistics')" class="link">
                  <InformationCircle />
                </inertia-link>
              </div>
              <div class="p-4" height="400">
                <lineChart
                  :height="300"
                  :startDate="dateRange.startDate"
                  :endDate="dateRange.endDate"
                  :data="statistics"
                  :errorData="statisticsError"
                  :render="renderLine"
                />
              </div>
            </div>
            <div
              class="
                mt-6
                bg-white
                shadow-allArround
                rounded-xl
                flex-1
                relative
                p-4
                flex
                justify-center
                items-center
                flex-col
                text-center
              "
              v-if="
                Object.keys(product).length === 0 &&
                !productLoading &&
                !remainderLoading &&
                !statisticsLoading &&
                !planLoading
              "
            >
              <div>Subscribe a plan to unlock the dashboard.</div>
              <inertia-link :href="$route('pricing') + '#products'" class="link mt-2"
                >Go to Plans</inertia-link
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </layout>
</template>

<script>
const layout = () =>
  import(/* webpackChunkName: "layout" */ "../../Components/Layout/layout.vue");
const DateRangePicker = () =>
  import(
    /* webpackChunkName: "dateRangePicker" */ /* webpackPrefetch: true */ "vue2-daterange-picker"
  );
const sideMenu = () =>
  import(
    /* webpackChunkName: "sideMenu" */ /* webpackPrefetch: true */ "../../Components/Layout/User/sideMenu.vue"
  );
const lineChart = () =>
  import(
    /* webpackChunkName: "lineChart" */ /* webpackPrefetch: true */ "../../Components/Layout/User/statisticsLineChart.vue"
  );
const donut = () =>
  import(
    /* webpackChunkName: "donut" */ /* webpackPrefetch: true */ "../../Components/Layout/User/donut.vue"
  );
import(
  /* webpackChunkName: "dateRangePicker" */ "vue2-daterange-picker/dist/vue2-daterange-picker.css"
);
const CalendarIcon = () =>
  import(/* webpackChunkName: "CalendarIcon" */ "@vue-hero-icons/outline").then(
    (Import) => Import.CalendarIcon
  );
const alertBox = () =>
  import(/* webpackChunkName: "alertBox" */ "../../Components/alertBox.vue");

const ChartBarIcon = () =>
  import(/* webpackChunkName: "ChartBarIcon" */ "@vue-hero-icons/outline").then(
    (Import) => Import.ChartBarIcon
  );

const InformationCircle = () =>
  import(
    /* webpackChunkName: "InformationCircle" */ "@vue-hero-icons/outline"
  ).then((Import) => Import.InformationCircleIcon);

export default {
  components: {
    layout,
    sideMenu,
    lineChart,
    donut,
    DateRangePicker,
    CalendarIcon,
    alertBox,
    ChartBarIcon,
    InformationCircle,
  },
  props: {
    errors: Object,
  },
  data() {
    return {
      dateRange: {
        startDate: null,
        endDate: Date.now(),
      },
      selectionDate: {
        startDate: null,
        endDate: null,
      },
      statistics: null,
      statisticsError: null,
      product: {},
      currPlan: {},
      planLoading: true,
      productLoading: true,
      remainderLoading: true,
      statisticsLoading: true,
      renderLine: 0,
      usedApiCalls: 0,
      statisticsRendered: false,
      statisticsErrorRendered: false,
    };
  },
  created() {
    this.daysAgo7();
    this.getPlan();
    this.getProduct();
    this.getUsedApiCalls();
    this.getStatistics();
    this.getStatisticsError();
  },
  methods: {
    updateValues() {
      this.getStatistics();
      this.getStatisticsError();
    },
    checkOpen() {},
    hoverDates() {
      if (this.selectionDate.startDate != null) {
        let day7 = new Date(this.selectionDate.startDate);
        day7.setDate(day7.getDate() + 7);
        if (this.$refs.picker.end > day7) {
          this.$refs.picker.end = day7;
        }
      }
    },
    selectionStartDate(date) {
      this.selectionDate.startDate = date;
    },
    selectionEndDate() {
      this.hoverDates();
    },
    daysAgo7() {
      let day7 = new Date(Date.now());
      this.dateRange.startDate = day7.setDate(day7.getDate() - 7);
    },
    getPlan() {
      this.axios
        .get("/user/api/plan")
        .then((response) => {
          if (response.data.plan_id) {
            this.currPlan = response.data;
          }
          this.planLoading = false;
        })
        .catch(() => {
          this.planLoading = false;
        });
    },
    getProduct() {
      this.axios
        .get("/user/api/product")
        .then((response) => {
          if (response.data.name) {
            this.product = response.data;
          }
          this.productLoading = false;
        })
        .catch(() => {
          this.productLoading = false;
        });
    },
    getUsedApiCalls() {
      this.axios
        .get("/user/api/used-api-calls")
        .then((response) => {
          if (response.data) {
            this.usedApiCalls = response.data;
          }
          this.remainderLoading = false;
        })
        .catch(() => {
          this.remainderLoading = false;
        });
    },
    getStatistics() {
      this.statisticsRendered = false;
      let startDate = new Date(this.dateRange.startDate);
      let endDate = new Date(this.dateRange.endDate);
      this.axios
        .post("/user/api/statistics", {
          startDate: startDate.toISOString().split("T")[0],
          endDate: endDate.toISOString().split("T")[0],
        })
        .then((response) => {
          if (response.data) {
            this.statistics = response.data;
          }
          this.statisticsRendered = true;
          this.renderCharts();
        });
    },
    getStatisticsError() {
      this.statisticsErrorRendered = false;
      let startDate = new Date(this.dateRange.startDate);
      let endDate = new Date(this.dateRange.endDate);
      this.statisticsLoading = true;
      this.axios
        .post("/user/api/get-statistics-errors", {
          startDate: startDate.toISOString().split("T")[0],
          endDate: endDate.toISOString().split("T")[0],
        })
        .then((response) => {
          if (response.data) {
            this.statisticsError = response.data;
          }
          this.statisticsErrorRendered = true;
          this.renderCharts();
          this.statisticsLoading = false;
        })
        .catch(() => {
          this.statisticsLoading = false;
        });
    },
    renderCharts() {
      if (this.statisticsRendered && this.statisticsErrorRendered) {
        this.renderLine++;
      }
    },
  },
  computed: {
    percentageUsageApi() {
      let percentage = (this.usedApiCalls / this.product.transactions) * 100;
      return percentage < 99 ? Math.ceil(percentage) : parseInt(percentage);
    },
  },
};
</script>